'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubNubMessageRecordInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PubNubMessageRecord = require('../pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _CommonMessage = require('../common-message-format/records/CommonMessage');

var _CommonMessage2 = _interopRequireDefault(_CommonMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pubNubMessageRecordInvariant = exports.pubNubMessageRecordInvariant = function pubNubMessageRecordInvariant(message) {
  return (0, _invariant2.default)(message instanceof _PubNubMessageRecord2.default || message instanceof _CommonMessage2.default, 'Expected message to be a `PubNubMessageRecord` or `CommonMessage` not a `%s`', typeof message === 'undefined' ? 'undefined' : _typeof(message));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/invariants/pubNubMessageRecordInvariant.js
// module id = 330
// module chunks = 2 3